"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SankeyChart = require("./SankeyChart");
Object.keys(_SankeyChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SankeyChart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SankeyChart[key];
    }
  });
});